/**
 * Swatch variant-name tooltip — touch/tap toggle (hover handled in CSS).
 */
(function () {
  const OPEN = 'aycan-swatch-tip--open';
  const BTN = '.aycan-swatch__btn';

  function closeAll(except) {
    document.querySelectorAll(`${BTN}.${OPEN}`).forEach((el) => {
      if (el !== except) el.classList.remove(OPEN);
    });
  }

  function bind() {
    if (document.documentElement.dataset.aycanSwatchTipBound === 'true') return;
    document.documentElement.dataset.aycanSwatchTipBound = 'true';

    document.addEventListener(
      'pointerdown',
      (event) => {
        if (!window.matchMedia('(hover: none)').matches) return;

        const btn = event.target.closest(BTN);
        if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
          closeAll();
          return;
        }

        if (event.target.closest('.aycan-swatch__qty, .aycan-qty__minus, .aycan-qty__plus, .aycan-qty__input')) {
          return;
        }

        const wasOpen = btn.classList.contains(OPEN);
        closeAll();
        if (!wasOpen) btn.classList.add(OPEN);
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
